import React, { useState } from 'react'
import { ColumnDefinition } from 'common/components/DataTable'
import GenericList from 'common/components/GenericList'
import { Button } from 'react-bootstrap'
import * as Icon from 'react-bootstrap-icons'
import OperationWorkflowModal from 'common/components/OperationWorkflowModal'
import API from 'common/logic/API'
import { ClassificationRule } from 'types'
import { useNavigate } from 'react-router-dom'

interface Props {
    query: Record<string, string>
    url: string
}

function ClassificationRulesList({ query, url }: Props) {
    const navigate = useNavigate()
    const [modal, setModal] = useState<{ type: string; id?: number; name?: string } | false>(false)
    const [dataKey, setDataKey] = useState(Date.now())

    const hideDialogs = () => setModal(false)
    const refreshData = () => setDataKey(Date.now())

    const showDeletionDialog = (id: number, name: string) => setModal({ type: "delete", id, name })

    const deletionModal = (params: { id: number; name: string }) => {
        const confirmationStep = () => `Delete rule "${params.name}"?`
        const executeStep = () => API.delete(`/classification-rules/${params.id}`)
        const completion = (result: unknown) => {
            hideDialogs()
            if (result) refreshData()
        }
        return <OperationWorkflowModal
            confirmationStep={confirmationStep}
            executionStep={executeStep}
            completionCallback={completion}
        />
    }

    let modalEl: React.ReactNode = null
    if (modal && (modal as any).type === "delete") {
        modalEl = deletionModal(modal as { id: number; name: string })
    }

    const definitions = [
        new ColumnDefinition<ClassificationRule>("Name", "name"),
        new ColumnDefinition<ClassificationRule>("Actions", obj => {
            return <>
                <Button variant="link" title="Edit"
                    onClick={() => navigate(`/classification-rules/${obj.id}/edit`)}><Icon.Pencil /></Button> |
                <Button variant="link" title="Delete"
                    onClick={() => showDeletionDialog(obj.id, obj.name)}><Icon.Trash /></Button>
            </>
        })
    ]

    return <>
        {modalEl}
        <GenericList
            title="Classification rules"
            description="These rules are applied to classify movements when imported from bank statements"
            columns={definitions as unknown as ColumnDefinition[]}
            beforeTable={<Button variant="link" onClick={() => navigate("/classification-rules/add")}>Add new</Button>}
            dataKey={dataKey}
            endpoint="/classification-rules"
        />
    </>
}

export default ClassificationRulesList
